var sectionThemeWeb = {
  descriptionColor: 'text.secondary'
};

export { sectionThemeWeb };
